<template>
  <div class="app-container">
    <BjRouteTabs :route-list="STOCK_DISTRIBUTION_ROUTE_LIST" />
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="4">
          <el-form-item :label="$t('goodsPage.skuCode')" prop="skuCode">
            <BjInput v-model="queryParams.skuCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('goodsPage.skuCode')" clearable. @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$t('BusinessStockDistributionQty.header.supportWarehouseCode')" prop="supportWarehouseCode">
            <BjInput v-model="queryParams.supportWarehouseCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessStockDistributionQty.header.supportWarehouseCode')" clearable. @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$t('BusinessStockDistributionQty.header.supportWarehouseName')" prop="supportWarehouseName">
            <BjInput v-model="queryParams.supportWarehouseName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessStockDistributionQty.header.supportWarehouseName')" clearable. @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$t('goodsPage.categoryName')" prop="categoryId">
            <BjGoodsTypeTreeSelect v-model="queryParams.categoryId" :placeholder="$t('goodsPage.categoryName')"/>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$t('BusinessStockDistributionQty.header.receiveWarehouseCode')" prop="receiveWarehouseCode">
            <BjInput v-model="queryParams.receiveWarehouseCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessStockDistributionQty.header.receiveWarehouseCode')" clearable. @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$t('BusinessStockDistributionQty.header.receiveWarehouseName')" prop="receiveWarehouseName">
            <BjInput v-model="queryParams.receiveWarehouseName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessStockDistributionQty.header.receiveWarehouseName')" clearable. @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="8">  </el-col> -->
        <!-- <el-col :span="8">  </el-col> -->
      </template>

      <template v-slot:tableOperation>
        <el-col>
          <el-button v-permission:BusinessStockDistributionQtyAddSku type="primary" @click="onAddSku">{{ $t('BusinessStockDistributionQty.commodityDistribution') }}</el-button>
          <el-button v-permission:BusinessStockDistributionQtyAddWarehouse type="primary" @click="onAddWarehouse">{{ $t('BusinessStockDistributionQty.batchAllocation') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <span v-else-if="col.prop === 'code'" class="link" @click="onView(scope.row)">
                {{ scope.row[col.prop] }}
              </span>
              <template v-else-if="col.prop === 'qty'">
                {{ $infinityNumber(scope.row[col.prop]) }}
              </template>
              <template v-else-if="col.prop === 'status'">
                {{ $t(STOCK_DISTRIBUTION_PLAN_STATUS_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <template v-else-if="['supportTypeCode', 'receiveTypeCode'].bjIncludes(col.prop)">
                {{ $store.state.values.STOCK_WAREHOUSE_TYPE.bjGet(scope.row[col.prop]) }}
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="scope">
              <el-button v-permission:BusinessStockDistributionQtyView type="text" @click="onView(scope.row)">{{ $t('viewText') }}</el-button>
              <el-button v-permission:BusinessStockDistributionQtyEdit type="text" class="edit-btn" @click="onEdit(scope.row)">{{ $t('editText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增/编辑弹窗 -->
    <!-- <DataForm ref="DataForm" @reFresh="reFresh" @batchDeleteApi="batchDeleteApi" /> -->
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { stockApi } from '@/api';
// import DataForm from './components/DataForm.vue';
import {
  STOCK_DISTRIBUTION_ROUTE_LIST,
  STOCK_DISTRIBUTION_PLAN_STATUS_LIST,
} from '@/utils/constants';
export default {
  name: 'BusinessStockDistributionQtyIndex',
  components: {
    // DataForm,
  },
  mixins: [pageMiXin],

  data() {
    return {
      STOCK_DISTRIBUTION_ROUTE_LIST,
      STOCK_DISTRIBUTION_PLAN_STATUS_LIST,
      queryApi: stockApi.getDistributeSpaces,
      // 查询参数
      queryParams: {
        categoryId: null,
        receiveWarehouseCode: null,
        receiveWarehouseName: null,
        skuCode: null,
        spuCode: null,
        spuName: null,
        supportWarehouseCode: null,
        supportWarehouseName: null,
      },

      labelList: [
        { label: 'BusinessStockDistributionQty.table.categoryName', prop: 'categoryName', isCheck: true, disabled: false, width: '135' },
        { label: 'BusinessStockDistributionQty.table.skuCode', prop: 'skuCode', isCheck: true, disabled: false, width: '140' },
        { label: 'BusinessStockDistributionQty.table.supportTypeCode', prop: 'supportTypeCode', isCheck: true, disabled: false, width: '180' },
        { label: 'BusinessStockDistributionQty.table.supportCode', prop: 'supportCode', isCheck: true, disabled: false, width: '180' },
        { label: 'BusinessStockDistributionQty.table.supportName', prop: 'supportName', isCheck: true, disabled: false, width: '180' },
        { label: 'BusinessStockDistributionQty.table.qty', prop: 'qty', isCheck: true, disabled: false, width: '135' },
        { label: 'BusinessStockDistributionQty.table.receiveTypeCode', prop: 'receiveTypeCode', isCheck: true, disabled: false, width: '200' },
        { label: 'BusinessStockDistributionQty.table.receiveCode', prop: 'receiveCode', isCheck: true, disabled: false, width: '200' },
        { label: 'BusinessStockDistributionQty.table.receiveName', prop: 'receiveName', isCheck: true, disabled: false, width: '200' },
        { label: 'BusinessStockDistributionQty.table.lastUpdateName', prop: 'lastUpdateName', isCheck: true, disabled: false, width: '120' },
        { label: 'BusinessStockDistributionQty.table.lastUpdateDate', prop: 'lastUpdateDate', isCheck: true, disabled: false, width: '147' },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: '120' },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.$store.dispatch('values/getValueList', 'STOCK.WAREHOUSE_TYPE');
  },
  methods: {
    /** 添加 */
    onAddSku() {
      this.$toPage('BusinessStockDistributionQtyAddSku');
    },
    /** 添加 */
    onAddWarehouse() {
      this.$toPage('BusinessStockDistributionQtyAddWarehouse');
    },
    /** 编辑操作 */
    onEdit(row) {
      this.$toPage('BusinessStockDistributionQtyEdit', { id: row.id });
    },
    /** 查看 */
    onView(row) {
      this.$toPage('BusinessStockDistributionQtyView', { id: row.id });
    },
    /** 删除操作 */
    // onDelete(row) {
    //   this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
    //     confirmButtonText: this.$t('toast.okText'),
    //     cancelButtonText: this.$t('toast.cancelText'),
    //     type: 'warning',
    //   })
    //     .then(() => {
    //       this.batchDeleteApi(row);
    //     })
    //     .catch(() => {});
    // },
    // /** 批量删除操作 */
    // onDeleteSelected() {
    //   if (!this.selectedRows.length) {
    //     this.$message.warning(this.$t('chooseText'));
    //     return;
    //   }
    //   const ids = this.selectedRows.map(e => e.id);
    //   this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
    //     confirmButtonText: this.$t('toast.okText'),
    //     cancelButtonText: this.$t('toast.cancelText'),
    //     type: 'warning',
    //   })
    //     .then(() => {
    //       this.batchDeleteApi({ ids: ids });
    //     })
    //     .catch(() => {});
    // },

    // operationApi(API_DATA) {
    //   stockApi.statusDistributePlans(API_DATA).then(res => {
    //     if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
    //       this.$message.success(this.$t('toast.operationSuccessText'));
    //       setTimeout(() => {
    //         this.reFresh();
    //       }, 500);
    //     }
    //   });
    // },
    // deleteApi(API_DATA) {
    //   stockApi.deleteOnlineShop(API_DATA).then(res => {
    //     if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
    //       this.$message.success(this.$t('toast.operationSuccessText'));
    //       setTimeout(() => {
    //         this.reFresh();
    //       }, 500);
    //     }
    //   });
    // },
    // batchDeleteApi(API_DATA) {
    //   stockApi.detailDistributePlans(API_DATA).then(res => {
    //     if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
    //       this.$message.success(this.$t('toast.operationSuccessText'));
    //       setTimeout(() => {
    //         this.reFresh();
    //       }, 500);
    //     }
    //   });
    // },
  },
};
</script>
<style lang="scss" scoped>
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
</style>
